import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_BEACHTENNIS } from 'src/app/core/constants';

@Component({
  selector: 'app-beachtennis-home',
  templateUrl: './beachtennis-home.component.html',
  styleUrls: ['./beachtennis-home.component.scss']
})
export class BeachtennisHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Beach tennis
   */
  public departmentType: string = DEPARTMENT_TYPE_BEACHTENNIS;

  constructor(public setupService: SetupService) { }

  ngOnInit(): void {
  }

}
